import newLogo from "../../../assets/images/GEN_Wing_negative_HIGH_FIX.png";
import React from "react";
import {useSelector} from "react-redux";

const Logo = () => {
  const langData = useSelector(state => state.theme.langData);

  const linkToIntro = () => {
    if(window) {

      if(!window.pc) {
        return;
      }

      if(!window.pc.app){
        return;
      }

      window.pc.app.destroy();
    }
    window.location.href = `/${langData.lang}/intro`;
  }


  return (
    <>
      <div className="logo" onClick={linkToIntro}>
        {/*<img src={logoWhite} className="logo-white"/>*/}
        {/*<img src={logoDark} className="logo-dark"/>*/}
        <img src={newLogo} alt={"logo"}/>
      </div>
    </>
  )
}

export default Logo;
